import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MainNavigationComponent } from './core/components/main-navigation/main-navigation.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MainNavigationComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {}
